export default __webpack_public_path__ + "static/media/the-holistic-director.e403763d.jpg";